import { assertOk, requestJson } from "./storeApi";

const QUESTIONNAIRE_PATH = "/checkoutpage/questionnaire";

export async function fetchQuestions() {
	const { response, payload } = await requestJson(QUESTIONNAIRE_PATH);
	assertOk(response, payload, "Failed to load questions");
	if (!Array.isArray(payload) || payload.some((item) =>
		!Number.isInteger(item?.id) || item.id <= 0 || typeof item.question !== "string"
	)) {
		throw new Error("The server returned an invalid questionnaire.");
	}
	return payload;
}

export async function createQuestions(questions) {
	const { response, payload } = await requestJson(QUESTIONNAIRE_PATH, {
		method: "POST",
		body: JSON.stringify({ questions }),
	});
	return assertOk(response, payload, "Failed to add questions");
}

export async function updateQuestion(id, question) {
	const { response, payload } = await requestJson(QUESTIONNAIRE_PATH, {
		method: "PUT",
		body: JSON.stringify({ questions: [{ question_id: id, new_question: question }] }),
	});
	return assertOk(response, payload, "Failed to update question");
}

export async function deleteQuestion(id) {
	const { response, payload } = await requestJson(`${QUESTIONNAIRE_PATH}/${id}`, { method: "DELETE" });
	return assertOk(response, payload, "Failed to delete question");
}
